import { MessageType } from "../enums.generated";

/**
 * Gets the icon class for a given MessageType.
 * @param type The message type.
 * @returns Icon class string.
 */
export function getMessageIcon(type: MessageType) {

	let iconClass = "fas ";
	switch (type) {
		case MessageType.Error:
			iconClass += "fa-exclamation-circle";
			break;
		case MessageType.Success:
			iconClass += "fa-thumbs-up";
			break;
		case MessageType.Warning:
			iconClass += "fa-exclamation-triangle";
			break;
		default:
			iconClass += "fa-info-circle";
			break;
	}
	return iconClass;
}